import * as React from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { HelpIcon } from "@/components/ui/help-icon";

export interface DescriptionItem {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
  info?: string;
  copyable?: string;
}

interface DescriptionListProps {
  items: DescriptionItem[];
  className?: string;
}

export function DescriptionList({ items, className }: DescriptionListProps) {
  const copy = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => toast.success(`Copied: ${text}`));
  };

  return (
    <div
      className={cn(
        "flex flex-wrap items-center gap-x-6 gap-y-1.5",
        className
      )}
    >
      {items.map((item, i) => (
        <div key={i} className="flex items-baseline gap-1.5">
          <span className="inline-flex items-center text-xs text-muted-foreground">
            {item.label}
            {item.info && <HelpIcon text={item.info} />}
          </span>
          {item.copyable ? (
            <button
              type="button"
              onClick={() => copy(item.copyable!)}
              title="Click to copy"
              className={cn(
                "group inline-flex cursor-pointer items-center gap-1 text-[13px] text-foreground transition-colors duration-150 hover:text-primary",
                item.mono && "font-mono text-xs"
              )}
            >
              {item.value}
              <Copy
                size={11}
                className="opacity-0 transition-opacity duration-150 group-hover:opacity-100"
              />
            </button>
          ) : (
            <span
              className={cn(
                "text-[13px] text-foreground",
                item.mono && "font-mono text-xs"
              )}
            >
              {item.value}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
